module.exports = __webpack_public_path__ + "static/media/IMG_4556.2a8823db.jpg";